<template>
  <div class="home">
    <Header ref="header"></Header>
    <MainBannerEN @openVideo="openVideo" ref="banner"  v-if="lang=='EN'"></MainBannerEN>
    <MainBanner @openVideo="openVideo" ref="banner" v-else></MainBanner>
    <MainProduct @openVideo="openVideo"></MainProduct>
    <MainCoreTechnology></MainCoreTechnology>
    <MainSolution></MainSolution>
    <MainPartner></MainPartner>
<!--    <GroupNet></GroupNet>-->
    <Footer></Footer>
    <MyPlayer v-show="MyPlayer.showMyPlayer" @closeVideo="closeVideo"
              :srcPath="MyPlayer.srcPath"></MyPlayer>
  </div>
</template>

<script>
  import Header from '@/components/common/Header'
  import MainBanner from '@/components/common/home/MainBanner'
  import MainBannerEN from '@/components/common/home/MainBannerEN'
  import MainProduct from '@/components/common/home/MainProduct'
  import MainCoreTechnology from '@/components/common/home/MainCoreTechnology'
  import MainSolution from '@/components/common/home/MainSolution'
  import MainPartner from '@/components/common/home/MainPartner'
  import GroupNet from '@/components/common/home/GroupNet'
  import Footer from '@/components/common/Footer'
  import MyPlayer from '@/components/common/MyPlayer'
  import {mapGetters} from 'vuex'
  export default {
    name: 'Home',
    data () {
      return {
        MyPlayer: {
          srcPath:"",
          showMyPlayer:false
        },
      }
    },
    components: {
      Header,
      MainBanner,
      MainBannerEN,
      MainProduct,
      MainCoreTechnology,
      MainSolution,
      MainPartner,
      GroupNet,
      Footer,
      MyPlayer
    },
    methods: {
      closeVideo(){
        this.MyPlayer.srcPath='';
        this.MyPlayer.showMyPlayer = false;
      },
      openVideo (param) {
        this.MyPlayer.srcPath = param.srcPath
        this.MyPlayer.showMyPlayer = true
      },
      scrollEvent () {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 0) {
          this.$refs.header.setHeaderFixed(true)
        } else {
          this.$refs.header.setHeaderFixed(false)
        }
      },
    },
    mounted () {
      $('html,body').scrollTop(0)
      window.addEventListener('scroll', this.scrollEvent);
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.scrollEvent)
    },
    computed: {
      ...mapGetters(['lang']),
    },

  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue